import type { NamedFieldProps } from "./Field.js";
import { BooleanStore, FileSchema, getSource } from "shelving";
import { useInstance, useStore } from "shelving/react";
import { Icon } from "../base/Icon.js";
import { MediaPhoto } from "../media/MediaImage.js";
import { Field, useField } from "./Field.js";
import { FieldNotice } from "./FieldNotice.js";
import { FileInput } from "./FileInput.js";

/** Allow the user to select and upload a single image. */
export function MediaField(props: { uploader: (file: File) => Promise<string> } & NamedFieldProps): React.ReactElement {
	const field = useField<string | null>(props);
	const { name, form, schema, value, placeholder = "Choose..." } = field;
	const { types } = getSource(FileSchema, schema);
	useStore(form);
	useStore(form.busy);
	const busy = useStore(useInstance(BooleanStore));
	return (
		<Field {...field}>
			<div className={`input space-none pad-none gap-none ${busy.value ? "effect-waiting" : ""}`}>
				<label className="input space-none pad-none flex-full gap-none">
					<FileInput
						onFiles={async file => {
							busy.set(true);
							const uploaded = await props.uploader(file);
							form.publish(name, uploaded);
							busy.set(false);
						}}
						disabled={busy.value || form.busy.value}
						types={types}
					/>
					{value ? (
						<span className="input flex-full">
							<MediaPhoto path={value} mods="size-4x" />
						</span>
					) : (
						<span className="input input-placeholder flex-full">{placeholder}</span>
					)}
					<span className="input">
						<Icon icon="more" />
					</span>
				</label>
				{value ? (
					<button
						type="button"
						className="input space-none"
						onClick={e => {
							e.stopPropagation();
							e.preventDefault();
							form.publish(name, null);
							return false;
						}}
						title="Clear"
						disabled={form.busy.value}
					>
						<Icon icon="close" />
					</button>
				) : null}
			</div>
			<FieldNotice name={name} />
		</Field>
	);
}
